"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var formInputTypes = {
  currency: 'CURRENCY',
  inputText: 'INPUT_TEXT',
  textArea: 'TEXT_AREA',
  select: 'SELECT',
  selectCreate: 'SELECT_CREATE',
  inputNumber: 'NUMBER',
  slider: 'SLIDER',
  radio: 'RADIOBUTTON',
  check: 'CHECK',
  email: 'EMAIL',
  date: 'DATE',
  button: 'BUTTON',
  numberFormat: 'NUMBER_FORMAT',
  numberRange: 'NUMBER_RANGE',
  companyLookup: 'COMPANY_LOOKUP',
  creditCard: 'CREDIT_CARD',
  iban: 'IBAN',
  sortCode: 'SORT',
  bic: 'SWIFT_BIC',
  extensionCustomInputs: 'EXT_CUSTOM_INPUTS',
  telephone: 'PHONE',
  url: 'URL',
  richText: 'RICH_TEXT'
};
var _default = formInputTypes;
exports.default = _default;